module.exports = __webpack_public_path__ + "media/images/header_old-e918d47b44ac5c235edb3650ae0ffb3c.png";